import { makeStyles } from '@material-ui/core/styles';

import { DOCUMENT_SCORE_PANEL_WIDTH } from 'src/data/ui';

export const useStyles = makeStyles(
  () => ({
    root: {
      width: DOCUMENT_SCORE_PANEL_WIDTH,
    },
  }),
  { name: 'DocumentScores' }
);
